import React from 'react';

const Rotate = (props: object) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3438 8.5C14.3438 5.27683 11.7148 2.65625 8.4623 2.65625C5.76771 2.65625 3.4995 4.45605 2.80207 6.90625H5.57812H6.375V8.5H5.57812H0.796875C0.356774 8.5 0 8.14322 0 7.70312V2.92188V2.125H1.59375V2.92188V5.56056C2.73967 2.91299 5.38512 1.0625 8.4623 1.0625C12.5865 1.0625 15.9375 4.38814 15.9375 8.5C15.9375 12.6119 12.5865 15.9375 8.4623 15.9375C5.97516 15.9375 3.77051 14.7281 2.41236 12.8692L1.94225 12.2258L3.2291 11.2856L3.69921 11.929C4.76883 13.3929 6.50308 14.3438 8.4623 14.3438C11.7148 14.3438 14.3438 11.7232 14.3438 8.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Rotate;
